import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@app/@auth';
import { AuthService } from '@app/@auth/shared/auth.service';
import { PathMap } from '@app/@core/enums';
import { AlertService } from '@app/@core/services';

@Component({
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  returnUrl: string;
  loginForm: Partial<User>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService
  ) {
    this.returnUrl =
      this.activatedRoute.snapshot.queryParams.returnUrl ||
      `${PathMap.App}/${PathMap.AppHome}`;
    this.loginForm = {
      usuario: '',
      password: '',
    };
  }

  ngOnInit(): void {}

  onSubmit({ usuario, password }) {
    this.authService.login(usuario, password).subscribe((data: any) => {
      if (data.usuario && data.estado === 'Activo') {
        this.router.navigate([this.returnUrl]);
      } else if (data.estado !== 'Activo') {
        localStorage.removeItem('currentUser');
        this.alertService.showError(
          'El usuario no se encuentra activo en el sistema.'
        );
      }
    });
  }
}
